import { useQuery } from 'react-query';
import { getProducts } from '../../services/product.service';

export const getProductsQueryKey = 'getProducts';
export const useProductsList = (params: { skip: number; limit: number; name?: string }) => useQuery(
  [getProductsQueryKey, params],
  () => getProducts(params).then((result) => result.data),
  { refetchOnWindowFocus: false, retry: false },
);
